<template>
  <div class="formCommon">
    <el-form ref="formCommon"
             label-position="right"
             label-width="120px"
             :model="formLabelAlign"
             :rules="rules">
      <el-form-item v-for="(item, index) in formArray"
                    :key="index"
                    :label="item.label"
                    :prop="item.props">
        <el-input v-if="item.type === 'input'"
                  v-model="formLabelAlign[item.props]"
                  clearable
                  :placeholder="'请输入' + item.label"
                  @keyup.enter.native="onSubmit" />
        <searchSite v-else-if="item.type === 'cascader'"
                    v-model="formLabelAlign[item.props]" />
        <el-select v-else-if="item.type === 'select'"
                   v-model="formLabelAlign[item.props]"
                   filterable
                   clearable
                   :placeholder="'请选择' + item.label">
          <el-option v-for="(g, i) in item.list"
                     :key="i"
                     :label="g.name"
                     :value="g.id" />
        </el-select>
        <el-date-picker v-else-if="item.type === 'date'"
                        v-model="formLabelAlign[item.props]"
                        type="date"
                        placeholder="选择日期"
                        format="yyyy 年 MM 月 dd 日"
                        value-format="yyyy-MM-dd" />
        <el-input v-else-if="item.type === 'textarea'"
                  type="textarea"
                  :rows="item.row ? item.row : '3'"
                  placeholder="请输入内容"
                  v-model="formLabelAlign[item.props]">
        </el-input>
        <el-time-picker v-else-if="item.type === 'timePicker'"
                        v-model="formLabelAlign[item.props]"
                        :picker-options="{
                          selectableRange: '00:30:00 - 23:59:59'
                        }"
                        :placeholder="'请选择' + item.label">
        </el-time-picker>
        <i class="el-icon-circle-plus form-icon"
           v-if="item.icon"
           @click="$emit('handleIcon')"></i>
        <uploadImage v-model="formLabelAlign[item.props]"
                     v-else-if="item.type === 'upload'" />
      </el-form-item>
      <el-form-item>
        <slot name="btn"></slot>
        <el-button type="primary"
                   size="small"
                   plain
                   @click="onSubmit('formCommon')"
                   v-if="formSubmitShow">
          提交
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import uploadImage from '@/components/upload/uploadImage.vue';
import searchSite from '@/components/searchSite/index.vue';

export default {
  components: { uploadImage, searchSite },
  props: {
    formArray: {
      type: Array,
      default() {
        return [];
      },
    },
    getData: {
      type: Function,
      default() {
        return null;
      },
    },
    rules: {
      type: Object,
      default() {
        return {};
      },
    },
    formSubmitShow: {
      type: Boolean,
      default() {
        return true;
      },
    },
    initialFormLabelAlign: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      formLabelAlign: {},
      selectedProject: null,
      list: [],
    };
  },
  mounted() {
    this.formLabelAlign = this.initialFormLabelAlign;
  },
  methods: {
    resetForm() {
      this.formLabelAlign = {};
      this.onSubmit();
    },
    onSubmit(formName) {
      console.log(Object.keys(this.rules));
      if (Object.keys(this.rules).length === 0) {
        this.$emit('getData', this.formLabelAlign);
        return;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit('getData', this.formLabelAlign);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
  watch: {
    formArray: {
      handler(newVal, oldVal) {
        if (newVal.some(item => item.type === 'timePicker')) {
          this.formLabelAlign[newVal.find(item => item.type === 'timePicker').props] = new Date(
            2016,
            9,
            10,
            18,
            40,
          );
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
<style lang="less" scoped>
.formCommon {
  .el-input,
  .el-textarea {
    width: 194px;
  }
  .form-icon {
    margin-left: 10px;
    color: #606266;
  }
}
</style>
